import React from "react";
import Question from '../components/Question'

import QuoteStepBase, { mapInsuranceStepProps, getInsuranceStepMapDispatch } from '../components/QuoteStepBase'
import ButtonContinue from "../components/ButtonContinue";
import { ICurrentInsuranceStepProps, IQuoteStepState } from "../components/interfaces";
import QuoteStep from "./QuoteStepLayout";
import { ValidatableForm } from "../components/ValidatableForm";
import { connect } from "react-redux";
import { validationUtils } from "../validation/Validation";
import { PATHS, QUOTE_STEPS, COMPONENTS, QUOTE_QUESTIONS } from "../AppConstants";

interface IState extends IQuoteStepState {
    hasInsurance: string,
    currentInsuranceDetails: string,
    beenUninsured: string,
    uninsuredPeriod: string,
    visibleTellUsMore: boolean,
    visible3Years: boolean,
    visibleUninsurance: boolean,
    updatingStore: boolean,
    errors: any;
}

class CurrentInsurance extends QuoteStepBase<ICurrentInsuranceStepProps, IState> {
    constructor(props: ICurrentInsuranceStepProps) {
        super(props);

        this.next = this.next.bind(this);

        this.state = {
            hasInsurance: "",
            currentInsuranceDetails: "",
            beenUninsured: "",
            uninsuredPeriod: "",
            visibleTellUsMore: false,
            visible3Years: false,
            visibleUninsurance: false,
            updatingStore: false,
            errors: null
         };
    }

    componentDidMount() {
        super.componentDidMount();
        this.props.reportCurrentStep();
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.meta.propsSource === COMPONENTS.PROPS_SOURCES.APP_STORE) {
            const currentInsurance = nextProps.currentInsurance;
            nextProps.meta.propsSource = "";

            if (!currentInsurance) return prevState;

            const visible3Years = !!currentInsurance.currentInsuranceDetails
                && (currentInsurance.currentInsuranceDetails === QUOTE_QUESTIONS.CURRENT_INSURANCE.CURRENT_INSURANCE_DETAILS.OWN_POLICY
                    || currentInsurance.currentInsuranceDetails === QUOTE_QUESTIONS.CURRENT_INSURANCE.CURRENT_INSURANCE_DETAILS.ANOTHER_POLICY_PROOF_OF_INSURANCE)

            const visibleUninsurance = (!!currentInsurance.beenUninsured
                && (currentInsurance.beenUninsured === QUOTE_QUESTIONS.CURRENT_INSURANCE.WAS_UNINSURED.WITHIN_SIX_MONTHS
                || currentInsurance.beenUninsured === QUOTE_QUESTIONS.CURRENT_INSURANCE.WAS_UNINSURED.WITHIN_THREE_YEARS))
                || (!!currentInsurance.currentInsuranceDetails && (currentInsurance.currentInsuranceDetails === QUOTE_QUESTIONS.CURRENT_INSURANCE.CURRENT_INSURANCE_DETAILS.OVERSEAS
                || currentInsurance.currentInsuranceDetails === QUOTE_QUESTIONS.CURRENT_INSURANCE.CURRENT_INSURANCE_DETAILS.POLICY_EXPIRED_LESS_30_DAYS));

            return {
                ...prevState,
                hasInsurance: currentInsurance.hasInsurance,
                currentInsuranceDetails: currentInsurance.currentInsuranceDetails,
                visible3Years: visible3Years,
                visibleUninsurance: visibleUninsurance,
                beenUninsured: currentInsurance.beenUninsured,
                visibleTellUsMore: !!currentInsurance.hasInsurance,
                uninsuredPeriod: currentInsurance.uninsuredPeriod
            };
        }

        return prevState;
    }

    next(event : React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        event.preventDefault();

        this.setState({ updatingStore: true }, () => {
            const updatedCurrentInsurance = {
                ...this.props.currentInsurance,
                hasInsurance: this.state.hasInsurance,
                currentInsuranceDetails: this.state.currentInsuranceDetails,
                beenUninsured: this.state.beenUninsured,
                uninsuredPeriod: this.state.uninsuredPeriod
            };

            this.props.updateAppState({ quoteUid: this.props.quoteUid, currentInsurance: updatedCurrentInsurance })
                .then(() => this.props.history.push(PATHS.INSURANCE_HISTORY),
                    () => {
                        this.setState({ ...this.state, updatingStore: false });
                    });
        });
    }
    
    callbackFunctionCurrentInsurance = (childData:string) => {
        switch (childData) {
            case QUOTE_QUESTIONS.YES_NO.YES:
                this.setState({
                    hasInsurance: childData,
                    currentInsuranceDetails : "",
                    beenUninsured : "",
                    visibleTellUsMore: true,
                    visible3Years:false,
                    visibleUninsurance:false
                });
                break;
            case QUOTE_QUESTIONS.YES_NO.NO:
                this.setState({
                    hasInsurance: childData,
                    currentInsuranceDetails: "",
                    beenUninsured: "",
                    visibleTellUsMore: true,
                    visible3Years:false,
                    visibleUninsurance:false
                });
                break;
        }
    };

    callbackFunctionTellUsMore = (childData:string) => {
        switch (childData) {
            case QUOTE_QUESTIONS.CURRENT_INSURANCE.CURRENT_INSURANCE_DETAILS.OWN_POLICY:
            case QUOTE_QUESTIONS.CURRENT_INSURANCE.CURRENT_INSURANCE_DETAILS.ANOTHER_POLICY_PROOF_OF_INSURANCE:
                this.setState({
                    currentInsuranceDetails : childData,
                    visible3Years:true,
                    visibleUninsurance: QUOTE_QUESTIONS.CURRENT_INSURANCE.WAS_UNINSURED.WITHIN_SIX_MONTHS === this.state.beenUninsured
                        || QUOTE_QUESTIONS.CURRENT_INSURANCE.WAS_UNINSURED.WITHIN_THREE_YEARS === this.state.beenUninsured
                });
                break;
            case QUOTE_QUESTIONS.CURRENT_INSURANCE.CURRENT_INSURANCE_DETAILS.ANOTHER_POLICY_WITHOUT_PROOF_OF_INSURANCE:
                this.setState({
                    currentInsuranceDetails: childData,
                    beenUninsured: "",
                    visible3Years:false,
                    visibleUninsurance: false
                });
                break;
            case QUOTE_QUESTIONS.CURRENT_INSURANCE.CURRENT_INSURANCE_DETAILS.OVERSEAS:
            case QUOTE_QUESTIONS.CURRENT_INSURANCE.CURRENT_INSURANCE_DETAILS.POLICY_EXPIRED_LESS_30_DAYS:
                this.setState({
                    currentInsuranceDetails: childData,
                    visibleUninsurance:true,
                    visible3Years: false,
                    beenUninsured: "",
                });
                break;
            case QUOTE_QUESTIONS.CURRENT_INSURANCE.CURRENT_INSURANCE_DETAILS.JUST_ACQUIRED_CAR:
            case QUOTE_QUESTIONS.CURRENT_INSURANCE.CURRENT_INSURANCE_DETAILS.POLICY_EXPIRED_MORE_30_DAYS:
                this.setState({
                    currentInsuranceDetails: childData,
                    visible3Years:false,
                    visibleUninsurance: false,
                    beenUninsured: "",
                });
        }
    };

    callbackFunction3Years = (childData:string) => {
        switch (childData) {
            case QUOTE_QUESTIONS.CURRENT_INSURANCE.WAS_UNINSURED.WITHIN_SIX_MONTHS:
            case QUOTE_QUESTIONS.CURRENT_INSURANCE.WAS_UNINSURED.WITHIN_THREE_YEARS:
                this.setState({
                    beenUninsured: childData,
                    visibleUninsurance:true
                });
                break;
            case QUOTE_QUESTIONS.CURRENT_INSURANCE.WAS_UNINSURED.NO:
                this.setState({
                    beenUninsured: childData,
                    visibleUninsurance:false
                });
                break;
        }
    };

    render() {
        return (
            <QuoteStep id={this.props.id}>
                <div className="titleArea"><h5>CURRENT INSURANCE</h5></div>
                <ValidatableForm hasErrors={null != this.state.errors}>
                    <Question
                        name="hasInsurance"
                        selectedValue={this.state.hasInsurance}
                        error={validationUtils.getValidationErrorFor(this.state.errors, "hasInsurance")}
                        selected={this.callbackFunctionCurrentInsurance}
                        items={[
                            QUOTE_QUESTIONS.YES_NO.YES,
                            QUOTE_QUESTIONS.YES_NO.NO
                        ]}
                        lable="Do you currently have car insurance?" />

                    <Question
                        name="currentInsuranceDetails"
                        selected={this.callbackFunctionTellUsMore}
                        selectedValue={this.state.currentInsuranceDetails}
                        style={{ display: this.state.visibleTellUsMore ? '' : 'none' }}
                        error={validationUtils.getValidationErrorFor(this.state.errors, "currentInsuranceDetails")}
                        items={QUOTE_QUESTIONS.YES_NO.YES === this.state.hasInsurance
                            ? [
                                QUOTE_QUESTIONS.CURRENT_INSURANCE.CURRENT_INSURANCE_DETAILS.OWN_POLICY,
                                QUOTE_QUESTIONS.CURRENT_INSURANCE.CURRENT_INSURANCE_DETAILS.ANOTHER_POLICY_PROOF_OF_INSURANCE,
                                QUOTE_QUESTIONS.CURRENT_INSURANCE.CURRENT_INSURANCE_DETAILS.ANOTHER_POLICY_WITHOUT_PROOF_OF_INSURANCE,
                            ]
                            : QUOTE_QUESTIONS.YES_NO.NO === this.state.hasInsurance
                                ? [
                                    QUOTE_QUESTIONS.CURRENT_INSURANCE.CURRENT_INSURANCE_DETAILS.OVERSEAS,
                                    QUOTE_QUESTIONS.CURRENT_INSURANCE.CURRENT_INSURANCE_DETAILS.JUST_ACQUIRED_CAR,
                                    QUOTE_QUESTIONS.CURRENT_INSURANCE.CURRENT_INSURANCE_DETAILS.POLICY_EXPIRED_MORE_30_DAYS,
                                    QUOTE_QUESTIONS.CURRENT_INSURANCE.CURRENT_INSURANCE_DETAILS.POLICY_EXPIRED_LESS_30_DAYS
                                ]
                                : []
                        }
                        lable="Tell us more" />

                    <Question
                        name="beenUninsured"
                        selected={this.callbackFunction3Years}
                        selectedValue={this.state.beenUninsured}
                        style={{ display: this.state.visible3Years ? '' : 'none' }}
                        error={validationUtils.getValidationErrorFor(this.state.errors, "beenUninsured")}
                        items={[
                            QUOTE_QUESTIONS.CURRENT_INSURANCE.WAS_UNINSURED.NO,
                            QUOTE_QUESTIONS.CURRENT_INSURANCE.WAS_UNINSURED.WITHIN_SIX_MONTHS,
                            QUOTE_QUESTIONS.CURRENT_INSURANCE.WAS_UNINSURED.WITHIN_THREE_YEARS
                        ]}
                        lable="Have you been uninsured at any time in the past 3 years?" />

                    <Question
                        name="uninsuredPeriod"
                        style={{ display: this.state.visibleUninsurance ? '' : 'none' }}
                        selected={(v) => this.setStateValue(v, "uninsuredPeriod")}
                        selectedValue={this.state.uninsuredPeriod}
                        error={validationUtils.getValidationErrorFor(this.state.errors, "uninsuredPeriod")}
                        items={QUOTE_QUESTIONS.YES_NO.NO === this.state.hasInsurance &&
                            QUOTE_QUESTIONS.CURRENT_INSURANCE.CURRENT_INSURANCE_DETAILS.POLICY_EXPIRED_LESS_30_DAYS === this.state.currentInsuranceDetails
                            ? [
                                QUOTE_QUESTIONS.CURRENT_INSURANCE.UNINSURED_PERIOD.WEEK,
                                QUOTE_QUESTIONS.CURRENT_INSURANCE.UNINSURED_PERIOD.MONTH
                            ]
                            : [
                                QUOTE_QUESTIONS.CURRENT_INSURANCE.UNINSURED_PERIOD.WEEK,
                                QUOTE_QUESTIONS.CURRENT_INSURANCE.UNINSURED_PERIOD.MONTH,
                                QUOTE_QUESTIONS.CURRENT_INSURANCE.UNINSURED_PERIOD.TWO_MONTHS,
                                QUOTE_QUESTIONS.CURRENT_INSURANCE.UNINSURED_PERIOD.THREE_MONTHS,
                                QUOTE_QUESTIONS.CURRENT_INSURANCE.UNINSURED_PERIOD.MORE_THEN_THREE_MONTHS
                            ]
                        }
                        lable="How long were you uninsured?" />

                    <div className="btnContainer">
                        <ButtonContinue
                            disabled={this.state.updatingStore}
                            showLoading={this.state.updatingStore}
                            onClick={this.next} />
                    </div>
                </ValidatableForm>
            </QuoteStep>
            
        );
    }
}

export default connect(mapInsuranceStepProps, getInsuranceStepMapDispatch(QUOTE_STEPS.CURRENT_INSURANCE))(CurrentInsurance);
